export default __webpack_public_path__ + "static/media/bloodragestance.ff001630.png";